"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iconsmindsIcons = void 0;
exports.iconsmindsIcons = [
    '24-hour',
    '3d-eyeglasses',
    'add',
    'add-bag',
    'add-basket',
    'add-cart',
    'add-file',
    'add-space-after-paragraph',
    'add-space-before-paragraph',
    'add-user',
    'address-book-2',
    'administrator',
    'aerobics',
    'affiliate',
    'air-balloon-1',
    'alarm-clock',
    'alarm-clock-2',
    'align-center',
    'align-justify-all',
    'align-justify-center',
    'align-justify-left',
    'align-justify-right',
    'align-left',
    'align-right',
    'ambulance',
    'anchor',
    'apple',
    'apple-bite',
    'archery',
    'arrow-around',
    'arrow-back',
    'arrow-back-2',
    'arrow-back-3',
    'arrow-barrier',
    'arrow-circle',
    'arrow-cross',
    'arrow-down',
    'arrow-down-2',
    'arrow-down-3',
    'arrow-down-in-circle',
    'arrow-fork',
    'arrow-forward',
    'arrow-forward-2',
    'arrow-from',
    'arrow-inside',
    'arrow-inside-45',
    'arrow-inside-gap',
    'arrow-inside-gap-45',
    'arrow-into',
    'arrow-junction',
    'arrow-left',
    'arrow-left-2',
    'arrow-left-in-circle',
    'arrow-loop',
    'arrow-merge',
    'arrow-mix',
    'arrow-next',
    'arrow-out-left',
    'arrow-out-right',
    'arrow-outside',
    'arrow-outside-45',
    'arrow-outside-gap',
    'arrow-outside-gap-45',
    'arrow-over',
    'arrow-refresh',
    'arrow-refresh-2',
    'arrow-right',
    'arrow-right-2',
    'arrow-right-in-circle',
    'arrow-shuffle',
    'arrow-squiggly',
    'arrow-through',
    'arrow-to',
    'arrow-turn-left',
    'arrow-turn-right',
    'arrow-up',
    'arrow-up-2',
    'arrow-up-3',
    'arrow-up-in-circle',
    'arrow-x-left',
    'arrow-x-right',
    'ask',
    'assistant',
    'at-sign',
    'atom',
    'baby-clothes',
    'back',
    'back-1',
    'back-2',
    'back-music',
    'bag-items',
    'bag-quantity',
    'ballet-shoes',
    'balloon',
    'band-aid',
    'bank',
    'bar-chart-4',
    'baseball',
    'basket-ball',
    'basket-coins',
    'basket-items',
    'basket-quantity',
    'battery-0',
    'battery-100',
    'battery-charge',
    'beard-3',
    'beer-glass',
    'behance',
    'bell',
    'belt',
    'berlin-tower',
    'bicycle',
    'bicycle-1',
    'big-bang',
    'big-data',
    'bikini',
    'billing',
    'bing',
    'binocular',
    'bio-hazard',
    'biotech',
    'bird-delivering-letter',
    'birthday-cake',
    'bisexual',
    'blackboard',
    'blinklist',
    'blogger',
    'blouse',
    'bone',
    'book',
    'bookmark',
    'books',
    'boot',
    'bottom-to-top',
    'bow-3',
    'bowling',
    'box',
    'box-close',
    'box-full',
    'box-with-folders',
    'bra',
    'brain',
    'bread',
    'broke-link-2',
    'broken-link',
    'brush',
    'bucket',
    'building',
    'bus-2',
    'business-man',
    'business-man-woman',
    'business-mens',
    'business-woman',
    'cake',
    'calculator',
    'calendar-1',
    'calendar-4',
    'camera-3',
    'camera-4',
    'can',
    'can-2',
    'cancer',
    'candle',
    'candy',
    'cap',
    'car',
    'car-items',
    'cart-quantity',
    'cash-register-2',
    'castle',
    'cd-2',
    'chair',
    'charger',
    'check',
    'checkout',
    'checkout-bag',
    'checkout-basket',
    'cheese',
    'chef-hat',
    'chemical',
    'chess',
    'chinese-temple',
    'chopsticks',
    'chrysler-building',
    'cinema',
    'city-hall',
    'clef',
    'clinic',
    'clock',
    'clock-2',
    'clock-back',
    'clock-forward',
    'close',
    'clothing-store',
    'cloud-hail',
    'cloud-moon',
    'cloud-rain',
    'cloud-snow',
    'cloud-sun',
    'cloud-weather',
    'coat',
    'cocktail',
    'coding',
    'coffee',
    'coffee-bean',
    'coffee-to-go',
    'coins',
    'coins-2',
    'colosseum',
    'column',
    'communication-tower-2',
    'compass-1',
    'compass-2',
    'computer',
    'conference',
    'consulting',
    'control',
    'control-2',
    'cookies',
    'copyright',
    'couple-sign',
    'cow',
    'cpu',
    'credit-card',
    'credit-card-3',
    'cricket',
    'croissant',
    'crop-2',
    'crown-2',
    'cupcake',
    'cursor',
    'cursor-click',
    'cursor-click-2',
    'cursor-move-2',
    'cursor-select',
    'danger',
    'dashboard',
    'data-center',
    'data-cloud',
    'data-download',
    'data-storage',
    'decrase-inedit',
    'deer',
    'delete-file',
    'delicious',
    'deviantart',
    'diamond',
    'dice',
    'digg',
    'digital-drawing',
    'diigo',
    'diploma-2',
    'direction-east',
    'director',
    'disk',
    'dna',
    'dna-2',
    'doctor',
    'dog',
    'dollar',
    'dollar-sign-2',
    'double-circle',
    'doughnut',
    'down',
    'down-1',
    'down-2',
    'down-3',
    'download',
    'download-1',
    'downward',
    'dress',
    'dribble',
    'drill',
    'drop',
    'dry',
    'dumbbell',
    'duplicate-layer',
    'dvd',
    'earphones-2',
    'eci-icon',
    'edit-map',
    'eifel-tower',
    'eject',
    'eject-2',
    'el-castillo',
    'electric-guitar',
    'electricity',
    'email',
    'embassy',
    'empire-state-building',
    'empty-box',
    'end',
    'end-1',
    'end-2',
    'endways',
    'engineering',
    'envelope',
    'envelope-2',
    'environmental',
    'environmental-3',
    'equalizer',
    'eraser-2',
    'euro',
    'euro-sign-2',
    'evernote',
    'facebook',
    'factory',
    'factory-1',
    'family-sign',
    'fan',
    'fax',
    'feather',
    'feedburner',
    'female',
    'female-1',
    'female-2',
    'file',
    'file-clipboard',
    'file-clipboard-file---text',
    'file-copy',
    'file-edit',
    'file-horizontal',
    'file-zip',
    'files',
    'film',
    'film-video',
    'filter-2',
    'financial',
    'finger-print',
    'fire-flame-2',
    'fire-staion',
    'firewall',
    'first',
    'first-aid',
    'fish',
    'fit-to',
    'fit-to-2',
    'flash-2',
    'flask',
    'flickr',
    'flowerpot',
    'fog-day',
    'fog-night',
    'folder',
    'folder-add--',
    'folder-block',
    'folder-close',
    'folder-cloud',
    'folder-delete',
    'folder-edit',
    'folder-open',
    'folder-zip',
    'folders',
    'football',
    'football-2',
    'footprint',
    'footprint-2',
    'forest-1',
    'formspring',
    'formula',
    'forsquare',
    'forward',
    'friendster',
    'full-screen',
    'full-screen-2',
    'full-view',
    'full-view-2',
    'funny-bicycle',
    'gamepad-2',
    'gas-pump',
    'gaugage',
    'gaugage-2',
    'gear',
    'gear-2',
    'gears',
    'geo2',
    'geo2--',
    'gey',
    'gift-box',
    'glass-water',
    'glasses-3',
    'globe-2',
    'gloves',
    'go-bottom',
    'go-top',
    'golf',
    'google',
    'gowalla',
    'grave',
    'green-energy',
    'green-house',
    'guitar',
    'gymnastics',
    'half-moon',
    'hamburger',
    'handshake',
    'hanger',
    'hdd',
    'headphone',
    'headphones',
    'headset',
    'heart',
    'heels-2',
    'helicopter',
    'hipster-men',
    'hokey',
    'home',
    'home-1',
    'home-3',
    'home-4',
    'homosexual',
    'hot-dog',
    'hotel',
    'hub',
    'ice-cream',
    'icq',
    'id-card',
    'idea',
    'idea-2',
    'imdb',
    'inbox',
    'inbox-empty',
    'inbox-forward',
    'inbox-full',
    'inbox-into',
    'inbox-out',
    'inbox-reply',
    'increase-inedit',
    'indent-first-line',
    'indent-left-margin',
    'indent-right-margin',
    'information',
    'inifity',
    'instagram',
    'jacket',
    'japanese-gate',
    'jeans',
    'jeep',
    'jet',
    'jump-rope',
    'key',
    'key-lock',
    'keyboard',
    'king-2',
    'knife',
    'lantern',
    'laptop---phone',
    'laptop---tablet',
    'laptop-3',
    'laptop-secure',
    'last',
    'last-fm',
    'layer-backward',
    'layer-forward',
    'leafs',
    'leaning-tower',
    'left',
    'left---right',
    'left---right-3',
    'left-1',
    'left-2',
    'left-3',
    'left-to-right',
    'lesbian',
    'lesbians',
    'letter-close',
    'letter-open',
    'letter-sent',
    'library',
    'life-jacket',
    'life-safer',
    'light-bulb-2',
    'light-bulb-leaf',
    'lighthouse',
    'like',
    'line-chart-1',
    'line-chart-3',
    'line-spacing',
    'link',
    'link-2',
    'linkedin-2',
    'livejournal',
    'loading',
    'loading-2',
    'loading-3',
    'location-2',
    'lock-2',
    'lollipop',
    'loop',
    'loudspeaker',
    'love',
    'magic-wand',
    'magnifi-glass',
    'magnifi-glass--',
    'mail',
    'mail-2',
    'mail-3',
    'mail-add--',
    'mail-attachement',
    'mail-block',
    'mail-delete',
    'mail-favorite',
    'mail-forward',
    'mail-gallery',
    'mail-inbox',
    'mail-link',
    'mail-lock',
    'mail-love',
    'mail-money',
    'mail-open',
    'mail-outbox',
    'mail-password',
    'mail-photo',
    'mail-read',
    'mail-remove-x',
    'mail-reply',
    'mail-reply-all',
    'mail-search',
    'mail-send',
    'mail-settings',
    'mail-unread',
    'mail-video',
    'mail-with-at-sign',
    'mail-with-cursors',
    'mailbox-empty',
    'mailbox-full',
    'male',
    'male-1',
    'male-2',
    'male-female',
    'man-sign',
    'management',
    'map-marker',
    'map-marker-2',
    'map2',
    'maximize',
    'medal',
    'medical-sign',
    'medicine-3',
    'megaphone',
    'memory-card-2',
    'men',
    'mens',
    'mic',
    'microphone-4',
    'microscope',
    'mine',
    'minimize',
    'money-bag',
    'monitor',
    'monitor---laptop',
    'monitor---phone',
    'monitor---tablet',
    'monitor-3',
    'monitor-analytics',
    'monitor-vertical',
    'monitoring',
    'motorcycle',
    'mouse',
    'mouse-3',
    'museum',
    'mustache-2',
    'navigat-start',
    'navigate-end',
    'network',
    'new-mail',
    'newspaper',
    'newsvine',
    'next',
    'next-1',
    'next-2',
    'next-music',
    'no-smoking',
    'notepad',
    'office',
    'office-lamp',
    'old-clock',
    'old-radio',
    'old-sticky-2',
    'old-telephone',
    'old-tv',
    'on-off',
    'on-off-2',
    'on-off-3',
    'open-banana',
    'open-book',
    'opera-house',
    'optimization',
    'orientation',
    'orientation-1',
    'over-time-2',
    'palette',
    'palm-tree',
    'pantone',
    'paper',
    'password',
    'password-field',
    'pause',
    'pause-2',
    'paw',
    'pen',
    'pen-2',
    'pepper',
    'phone-3',
    'photo',
    'photo-album-2',
    'physics',
    'pi',
    'picasa',
    'pie-chart',
    'pie-chart-3',
    'pilates-2',
    'pinterest',
    'pipette',
    'piramids',
    'plane',
    'plant',
    'plasmid',
    'plaster',
    'plaxo',
    'play-music',
    'plug-in',
    'plurk',
    'pointer',
    'police',
    'police-station',
    'post-mail',
    'post-mail-2',
    'post-office',
    'posterous',
    'pound',
    'pound-sign-2',
    'power',
    'power-2',
    'power-3',
    'power-cable',
    'power-station',
    'prater',
    'preview',
    'previous',
    'pricing',
    'printer',
    'profile',
    'project',
    'pulse',
    'puzzle',
    'qik',
    'qr-code',
    'quill-3',
    'quotes',
    'radio',
    'radioactive',
    'rafting',
    'rain-drop',
    'receipt-4',
    'record',
    'record-1',
    'record-2',
    'record-music',
    'recycling-2',
    'reddit',
    'redirect',
    'redo',
    'refinery',
    'refresh',
    'reload',
    'reload-1',
    'reload-2',
    'remote-controll-2',
    'remove',
    'remove-bag',
    'remove-basket',
    'remove-cart',
    'remove-file',
    'rename',
    'repair',
    'repeat',
    'repeat-1',
    'repeat-2',
    'repeat-3',
    'repeat-4',
    'repeat-5',
    'repeat-6',
    'reset',
    'resize',
    'reverbnation',
    'rewind',
    'ribbon',
    'right',
    'right-1',
    'right-2',
    'right-3',
    'right-to-left',
    'road-2',
    'roof',
    'rotation',
    'rotation-390',
    'router',
    'rss',
    'ruler',
    'running-shoes',
    'safe-box',
    'sailing-ship',
    'sand-watch-2',
    'satelite-2',
    'save',
    'scale',
    'scissor',
    'scooter',
    'scroller',
    'scroller-2',
    'security-block',
    'security-bug',
    'security-camera',
    'security-check',
    'security-settings',
    'securiy-remove',
    'seed',
    'server-2',
    'share',
    'sharethis',
    'sheep',
    'shield',
    'ship',
    'shop',
    'shop-2',
    'shop-3',
    'shop-4',
    'shopping-bag',
    'shopping-basket',
    'shopping-cart',
    'shuffle',
    'shuffle-1',
    'shuffle-2',
    'shuffle-3',
    'skateboard',
    'skydiving',
    'skype',
    'smartphone-3',
    'smartphone-4',
    'smoking-pipe',
    'snorkel',
    'snow',
    'snow-storm',
    'snowflake-3',
    'soccer-ball',
    'solar',
    'sound',
    'soundcloud',
    'space-needle',
    'spam-mail',
    'speach-bubble',
    'speach-bubble-10',
    'speach-bubble-11',
    'speach-bubble-12',
    'speach-bubble-13',
    'speach-bubble-2',
    'speach-bubble-3',
    'speach-bubble-4',
    'speach-bubble-5',
    'speach-bubble-6',
    'speach-bubble-7',
    'speach-bubble-8',
    'speach-bubble-9',
    'speach-bubble-asking',
    'speach-bubble-comic',
    'speach-bubble-comic-2',
    'speach-bubble-comic-3',
    'speach-bubble-comic-4',
    'speach-bubble-dialog',
    'speach-bubbles',
    'speaker',
    'speaker-1',
    'spot',
    'spring',
    'ssl',
    'stamp',
    'stamp-2',
    'start',
    'start-1',
    'start-2',
    'start-ways',
    'statistic',
    'stethoscope',
    'stop',
    'stop-2',
    'stop-music',
    'stopwatch',
    'storm',
    'student-female',
    'student-hat',
    'student-male',
    'student-male-female',
    'students',
    'stumbleupon',
    'suitcase',
    'summer',
    'sun',
    'sun-cloudy-rain',
    'sunglasses-w-3',
    'sunrise',
    'sunset',
    'support',
    'swimming',
    'switch',
    'sync',
    'synchronize',
    'synchronize-2',
    't-shirt',
    'tablet-3',
    'tag',
    'tag-3',
    'taj-mahal',
    'target',
    'target-market',
    'taxi-sign',
    'technorati',
    'tee-mug',
    'telephone-2',
    'temperature',
    'temperature-2',
    'tennis',
    'tennis-ball',
    'test-tube',
    'testimonal',
    'the-white-house',
    'three-arrow-fork',
    'thunder',
    'tie',
    'time-backup',
    'timer',
    'to-bottom',
    'to-bottom-2',
    'to-left',
    'to-right',
    'to-top',
    'to-top-2',
    'tomato',
    'top-to-bottom',
    'tower',
    'tractor',
    'traffic-light',
    'train',
    'trash-with-men',
    'tree-3',
    'trekking',
    'triangle-arrow-down',
    'triangle-arrow-left',
    'triangle-arrow-right',
    'triangle-arrow-up',
    'tripod-with-camera',
    'trophy',
    'trophy-2',
    'trumpet',
    'tumblr',
    'turn-down',
    'turn-down-2',
    'turn-down-from-left',
    'turn-down-from-right',
    'turn-left',
    'turn-left-3',
    'turn-right',
    'turn-right-3',
    'turn-up',
    'turn-up-2',
    'tv',
    'twitter',
    'type-pass',
    'umbrella-2',
    'undo',
    'unlike',
    'unlock-2',
    'up',
    'up---down',
    'up---down-3',
    'up-1',
    'up-2',
    'up-3',
    'upgrade',
    'upload',
    'upload-1',
    'upward',
    'usb',
    'user',
    'ustream',
    'venn-diagram',
    'viddler',
    'video',
    'video-5',
    'video-6',
    'video-len',
    'video-tripod',
    'view-height',
    'view-width',
    'vimeo',
    'voice',
    'voicemail',
    'volume-down',
    'volume-up',
    'walkie-talkie',
    'wallet',
    'watch',
    'wave',
    'webcam',
    'weight-lift',
    'wheelchair',
    'wifi',
    'wind-turbine',
    'windmill',
    'windy',
    'witch-hat',
    'woman-man',
    'women',
    'wordpress',
    'wrench',
    'xanga',
    'yacht',
    'yahoo',
    'yelp',
    'yes',
    'ying-yang',
    'youtube'
];
